import { createContext } from 'react';

// Opzioni di paginazione
export interface PagingOptions {
	page: number;
	size: number;
	sortBy: string;
	sortDir: 'asc' | 'desc';
}

// Rappresenta un singolo contesto di paginazione: Valori totali
export interface PagingContextItem {
	pagingOptions: PagingOptions;
	totalPages: number;
	totalElements: number;
}

// Definisce l'interfaccia del contesto con le funzioni
export interface PagingContextType {
	pagingItems: Record<string, PagingContextItem>;
	setPagingOptions: (contextId: string, options: Partial<PagingOptions>) => void; // Aggiorna le opzioni
	setTotalInfo: (
		// Aggiorna i totali
		contextId: string,
		totalPages: number,
		totalElements: number
	) => void;
	resetPaging: (contextId: string) => void;
	getContextItem: (contextId: string) => PagingContextItem; // Ottiene un contesto specifico
}

// Valori di default
export const defaultPagingOptions: PagingOptions = {
	page: 0,
	size: 9,
	sortBy: '',
	sortDir: 'asc'
};

const PagingContext = createContext<PagingContextType | undefined>(undefined);

export default PagingContext;
